import styled from '@emotion/styled';
import Interchange from '../../UI/Interchange/Interchange';
import { font, mediaQueries, palette, remCalc, section } from '../../css';

const StyledBanner = styled('div')(() => ({
    position: 'relative',
    marginBottom: remCalc(15),
}));

const StyledText = styled('span')(({ focusStyle }) => focusStyle);

const StyledLink = styled('a')(({ focusStyle }) => ({
    display: 'flex',
    alignItems: 'center',
    margin: remCalc(5, 0),
    paddingLeft: section.padding.mobile,
    paddingRight: section.padding.mobile,
    color: palette('white'),
    fontSize: font.size.xs,
    zIndex: 2,
    [mediaQueries.medium]: {
        paddingLeft: section.padding.desktop,
        paddingRight: section.padding.desktop,
        fontSize: font.size.s,
        '& .arte-icon': {
            width: remCalc(12),
            height: remCalc(12),
        },
    },
    [mediaQueries.xlarge]: {
        position: 'absolute',
        top: remCalc(20),
        left: remCalc(30),
        margin: 0,
        padding: 0,
    },
    '& .arte-icon': {
        width: remCalc(10),
        height: remCalc(10),
    },
    ':focus,:hover': {
        '& span': focusStyle,
    },
}));

const StyledIcon = styled('div')(() => ({
    marginRight: remCalc(5),
}));

const StyledWrapper = styled('div')(() => ({
    position: 'relative',
}));

const StyledLogo = styled('div')(() => ({
    display: 'none',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: remCalc(35),
    right: 0,
    zIndex: 1,
    [mediaQueries.medium]: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    '& .arte-icon': {
        display: 'flex',
    },
}));

const StyledTitle = styled('h1')(() => ({
    margin: 0,
    padding: `0 ${section.padding.mobile}`,
    fontSize: font.size.m,
    fontWeight: font.weight.medium,
    lineHeight: font.lineHeight.m,
    color: palette('white'),
    [mediaQueries.medium]: {
        padding: 0,
        maxWidth: '45%',
        fontSize: font.size.l,
        lineHeight: font.lineHeight.l,
    },
    [mediaQueries.large]: {
        fontSize: font.size.xl,
        lineHeight: font.lineHeight.xl,
    },
    [mediaQueries.xlarge]: {
        maxWidth: '42%',
        fontSize: font.size.xxl,
        lineHeight: font.lineHeight.xxl,
    },
}));

const StyledSubtitle = styled('h2')(() => ({
    margin: 0,
    padding: `0 ${section.padding.mobile}`,
    fontFamily: font.family.header,
    fontSize: font.size.s,
    fontWeight: font.weight.thin,
    lineHeight: font.lineHeight.s,
    color: palette('white'),
    [mediaQueries.medium]: {
        padding: 0,
    },
    [mediaQueries.large]: {
        fontSize: font.size.m,
        lineHeight: font.lineHeight.m,
    },
}));

const StyledPlayer = styled('div')(() => ({
    position: 'relative',
    height: '100%',
    width: '44.5%',
    zIndex: 1,
    '& .video-embed': {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        paddingBottom: '56.25%',
    },
}));

const StyledTeaser = styled('div')(() => ({
    position: 'relative',
}));

// TODO: would it be better to move this to Interchange via a prop ?
// not sure as it is quite specific to this component... to be discussed
const StyledPicture = styled(Interchange)(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
}));

const StyledCaption = styled('div')(() => ({
    marginBottom: remCalc(15),
    [mediaQueries.medium]: {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        marginBottom: 0,
        top: 0,
        left: remCalc(76),
        bottom: 0,
        right: 0,
        zIndex: 1,
    },
    [mediaQueries.large]: {
        left: remCalc(86),
    },
}));

export {
    StyledBanner,
    StyledCaption,
    StyledIcon,
    StyledLink,
    StyledLogo,
    StyledPicture,
    StyledPlayer,
    StyledSubtitle,
    StyledTeaser,
    StyledText,
    StyledTitle,
    StyledWrapper,
};
